import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import { IDarkTheme } from "styles/darkTheme";

export const styles = makeStyles((theme: IDarkTheme) =>
  createStyles({
    avatar: {
      textTransform: "uppercase",
      fontSize: "22px",
      fontWeight: 700,
      color: theme.colors.semantic.semantic_grey,
      backgroundColor: "#FFB80C",
      width: "64px",
      height: "64px",
      "@media (max-width: 750px)": {
        margin: "0px 0px",
        fontSize: "16px"
      }
    }
  })
);
